import add from './follow/add'
import check from './follow/check'
import unlink from './follow/unlink'
export default {add,check,unlink}
